module.exports = __webpack_public_path__ + "img/W-V01.d9ac67b5.jpg";